import type { BranchAccountState } from './BranchAccount.types';

/**
 * Initial state object for the BranchAccountState.
 * @type {BranchAccountState}
 * @property {object} branchAccount - Object representing branch account details.
 * @property {string|undefined} branchAccount.viewBranchAccountId - The ID of the branch account being viewed, if any.
 * @property {string|undefined} branchAccount.userBranchAccountId - The ID of the branch account belonging to the user, if any.
 * @property {boolean|undefined} branchAccount.isBranchAccountOwner - Indicates whether the user is the owner of the branch account.
 */

export const INIT_STATE: BranchAccountState = {
  loading: false,
  error: null,
  branchAccount: {
    viewBranchAccountId: undefined,
    userBranchAccountId: undefined,
    isBranchAccountOwner: undefined,
  },
};
